<template>
  <div>
    <div class="selected-list clear">
      <span class="title">筛选条件：</span>
      <a href="#" class="conditions-btn" v-for="sku in selectedSkus" :key="sku.id">
        {{ sku.name }}：
        <span class="txt">{{ sku }}</span>
        <span class="p-ico close-ico" @click.prevent="sku.clear()"></span>
      </a>
      <span class="clear-btn" v-if="selectedSkus.length" @click.prevent="clearAll()">清空筛选条件</span>
      <span style="color: gray" v-else>请选择筛选条件</span>
    </div>
    <div class="m-screen">
      <component
        v-show="!sku.selected.length && specialOption(sku.id)"
        v-for="sku in skuList"
        :is="sku.id"
        :name="sku.name"
        :key="sku.id"
        :id="sku.id"
        v-model="sku.selected"
      ></component>
    </div>
  </div>
</template>

<style lang="scss">
  @import './index.scss';
</style>

<script>
  import SkuYear from './year'
  import SkuTrainingType from './trainning-type'
  import SkuTrainees from './trainees'
  import SkuJobCategory from './job-category'
  import SkuUnitCategory from './unit-Category'
  import SkuTrainingResult from './training-result'
  import { kebabCase, camelCase } from 'lodash'

  const skuOptions = {
    SkuYear,
    SkuTrainingType,
    SkuTrainees,
    SkuJobCategory,
    SkuUnitCategory,
    SkuTrainingResult
  }

  class SkuOption {
    id = ''
    name = ''
    visible = true
    selected = []

    toString() {
      return this.selected.map(item => item.name).join('、')
    }

    clear() {
      this.selected = []
    }

    constructor(id, name) {
      this.id = id
      this.name = name
    }
  }

  export default {
    props: {
      //不渲染的sku项，写中文就行
      excludes: {
        type: Array,
        default() {
          return []
        }
      }
    },
    components: skuOptions,
    data() {
      const skuList = []
      Object.keys(skuOptions).forEach(key => {
        if (this.excludes.indexOf(skuOptions[key].desc) > -1) return
        skuList.push(new SkuOption(kebabCase(key), skuOptions[key].desc))
      })
      return {
        skuList
      }
    },
    computed: {
      specialOption() {
        //特殊选项判断
        return id => {
          //特殊选项岗位类别和单位类别只有在选中特定项才显示
          const specialOptionId = ['skuJobCategory', 'skuUnitCategory'] //需要判断的sku项
          if (!(specialOptionId.indexOf(camelCase(id)) > -1)) return true
          const _thisSelectedSkus = this.selectedSkus, //代理已选sku项
            spcialOptionShowRequireAction = {
              //对应项所要进行的判断-以函数方式写入，便于以后接入
              skuJobCategory: () => {
                return _thisSelectedSkus.find(item => {
                  return item.selected.find(selected => selected.optionCode === 'slry')
                })
              }, //岗位类别条件-选中三类人员
              skuUnitCategory: () => {
                return _thisSelectedSkus.find(item => {
                  return item.selected.find(selected => selected.optionCode === 'fsgzry')
                })
              } //单位类别条件-选中放射工作人员
            }
          return spcialOptionShowRequireAction[camelCase(id)]()
        }
      },
      selectedSkus() {
        const result = this.skuList.filter(sku => {
          return sku.selected.length
        })
        this.$emit(
          'input',
          result.map(item => {
            return {
              type: item.id,
              ...item.selected[0]
            }
          })
        )
        return result
      }
    },
    methods: {
      getParams() {
        return this.selectedSkus
      },
      clearAll() {
        this.selectedSkus.forEach(sku => {
          sku.clear()
        })
      }
    },
    async created() {
      // await CommonModule.init()
    }
  }
</script>
